module.exports = function(obj){
var __t,__p='',__j=Array.prototype.join,print=function(){__p+=__j.call(arguments,'');};
with(obj||{}){
__p+='<!--  css in staticUCs.css  -->\r\n<div class="progressBar-container">\r\n    <div class="cw-texteNormal messages">\r\n        <span class="waitmessage"></span>\r\n        <span class="valueText ui-phx-ihm-texte-donnees"></span>\r\n    </div>\r\n    <div class="progressBarContainer">\r\n        <div class="progress-bar"></div>\r\n        ';
 if (!isBtnStop){ 
__p+='\r\n            <div class="btnPause btn btn-secondary btn-onlyIcon">\r\n                '+
((__t=(UTILS.getSVGIcon('rectangle_debout','')))==null?'':__t)+
'\r\n        ';
 }else { 
__p+='\r\n            <div class="btnStop btn btn-secondary btn-onlyIcon">\r\n                '+
((__t=(UTILS.getSVGIcon('carre','')))==null?'':__t)+
'\r\n        ';
}
__p+='\r\n            </div>\r\n    </div>\r\n</div>';
}
return __p;
};
